"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FEATURED_PHRASE_SEGMENT = exports.COMPONENT_NAME = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gerenciatdUnifiedcomponents = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.text-info"));

var _gerenciatdUnifiedcomponents2 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.image"));

var _gerenciatdUnifiedcomponents3 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.button"));

var _FeaturedPhraseUtils = require("./FeaturedPhraseUtils");

var _gerenciatdUtils = require("@bit/gerenciatd.utils.common");

require("./FeaturedPhrase.scss");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const FEATURED_PHRASE_SEGMENT = {
  GP: 'gp',
  EMP: 'emp',
  DEFAULT: ''
};
exports.FEATURED_PHRASE_SEGMENT = FEATURED_PHRASE_SEGMENT;
const COMPONENT_NAME = 'FeaturedPhrase';
exports.COMPONENT_NAME = COMPONENT_NAME;

const FeaturedPhrase = ({
  components,
  backgroundImg,
  titleImage,
  altImage,
  segment
}) => {
  // Solo pintamos si hay frase
  if (components && components['TextInfo-1'] && components['TextInfo-1'].text !== undefined && components['TextInfo-1'].text !== '') {
    const idFeaturedPhrase = `FeaturedPhrase${(0, _gerenciatdUtils.giveRandomNumber)(0, 1000)}`;

    if (backgroundImg) {
      (0, _FeaturedPhraseUtils.generateBgFeaturedPhrase)(idFeaturedPhrase, backgroundImg);
    }

    return /*#__PURE__*/(0, _jsxRuntime.jsx)("section", {
      id: idFeaturedPhrase,
      className: `FeaturedPhrase ${backgroundImg ? '' : `FeaturedPhrase__bgColor${segment}`}`,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "FeaturedPhrase__container container",
        children: [titleImage && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, {
          src: titleImage,
          className: "FeaturedPhrase__image",
          alt: altImage
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, _objectSpread(_objectSpread({}, components['TextInfo-1']), {}, {
          segment: components['TextInfo-1'].segment || segment,
          className: `FeaturedPhrase__phrase ${!titleImage ? 'FeaturedPhrase__phrase-noImage' : ''}`
        })), components && components['TextInfo-2'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, _objectSpread(_objectSpread({}, components['TextInfo-2']), {}, {
          segment: components['TextInfo-2'].segment || segment,
          className: "FeaturedPhrase__autor"
        })), components && components['Button-1'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents3.default, _objectSpread(_objectSpread({}, components['Button-1']), {}, {
          segment: components['Button-1'].segment || segment,
          className: "FeaturedPhrase__button"
        }))]
      })
    });
  }

  return null;
};

FeaturedPhrase.propTypes = {
  /**
   * {
   *  "info": "Establece los elementos que aparecerán dentro del componente",
   *  "kind": "both",
   *  "beautifulName": "Texto"
   * }
   */
  components: _propTypes.default.object.isRequired,

  /**
   * {
   *  "info": "Establece la imagen de fondo que tendra el componente",
   *  "kind": "both",
   *  "beautifulName": "Imagen de fondo"
   * }
   */
  backgroundImg: _propTypes.default.string,

  /**
   * {
   *  "info": "Establece la imagen decorativa que tendra el componente",
   *  "kind": "both",
   *  "beautifulName": "imagen decorativa"
   * }
   */
  titleImage: _propTypes.default.string,

  /**
   * {
   *  "info": "Establece la propiedad alt de la imagen decorativa",
   *  "kind": "both",
   *  "beautifulName": "imagen decorativa"
   * }
   */
  altImage: _propTypes.default.string,

  /**
   * {
   *  "info": "Establece el segmento donde se consume el componente",
   *  "kind": "both",
   *  "beautifulName": "Segmento"
   * }
   */
  segment: _propTypes.default.string
};
FeaturedPhrase.defaultProps = {
  backgroundImg: '',
  titleImage: '',
  altImage: '',
  segment: FEATURED_PHRASE_SEGMENT.DEFAULT
};
var _default = FeaturedPhrase;
exports.default = _default;

//# sourceMappingURL=index.js.map